export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENT = 'SET_CLIENT'
export const SET_ESTATE = 'SET_ESTATE'
export const CREATE_CLIENT = 'CREATE_CLIENT'
export const EDIT_CLIENT = 'EDIT_CLIENT'
export const ENABLE_CLIENT = 'ENABLE_CLIENT'
export const DISABLE_CLIENT = 'DISABLE_CLIENT'



// WEBPACK FOOTER //
// ./src/store/modules/Clients/types.js